if(document.querySelector('.layer-toggle1')){
  let layerToggleOne = document.querySelectorAll('.layer-toggle1');
  let layerToggleTwo = document.querySelectorAll('.layer-toggle2');
    
  layerToggleOne.forEach(i => {
    
   i.onclick = e => {
    e.target.classList.add('toggle-active');
    e.target.closest('span').querySelector('.layer-toggle2').classList.remove('toggle-active');
    e.target.closest('div').querySelector('.layer1').style.cssText = 'opacity: 1;';
    e.target.closest('div').querySelector('.layer2').style.cssText = 'opacity: 0;';
     
    } 
  })

  layerToggleTwo.forEach(i => {
    
   i.onclick = e => {
     
    e.target.classList.add('toggle-active');
    e.target.closest('span').querySelector('.layer-toggle1').classList.remove('toggle-active');    
    e.target.closest('div').querySelector('.layer1').style.cssText = 'opacity: 0;';
    e.target.closest('div').querySelector('.layer2').style.cssText = 'opacity: 1;';
     
    } 
  })
}